import "./mobxSetup.js";
import { makeObservable, observable, action } from "mobx";
import isClientSide from "../common-utils/environment/isClientSide.util.js";
export class FeatureDiscoveryStore {
    open = false;
    tourId = "";
    /*
     * When viewed is undefined we don't have anyting in localstorage, this means we need to fetch and post the viewed tour's completion
     * If viewed is either true or false we already now the status in the api, no need to fetch or post
     */
    viewed = undefined;
    constructor(tourId) {
        makeObservable(this, {
            open: observable,
            viewed: observable,
            tourId: observable,
            start: action,
            stop: action,
            restart: action,
            setViewed: action,
        });
        this.tourId = tourId;
        this.viewed = this.#getTourIdStatus();
        this.open = !this.viewed;
    }
    // Start tour
    start = () => {
        if (this.open)
            return;
        this.open = true;
    };
    // Stop tour
    stop = () => {
        if (!this.open)
            return;
        this.#setTourIdTrue();
        this.open = false;
    };
    // Restart tour
    restart = () => {
        if (this.open)
            return;
        this.#setTourIdFalse();
        this.viewed = false;
        this.open = true;
    };
    // Set if the tour is viewed or not
    setViewed = () => {
        if (this.viewed)
            return;
        this.#setTourIdTrue();
        this.viewed = true;
    };
    // Get localStorage tour status
    #getTourIdStatus = () => {
        if (!isClientSide())
            return undefined;
        const status = window.localStorage.getItem(this.tourId);
        return status ? Boolean(JSON.parse(status)) : undefined;
    };
    // Set localStorage tour status true
    #setTourIdTrue = () => {
        if (!isClientSide() || this.#getTourIdStatus())
            return;
        window.localStorage.setItem(this.tourId, JSON.stringify(true));
    };
    // Set localStorage tour status false
    #setTourIdFalse = () => {
        if (!isClientSide() || !this.#getTourIdStatus())
            return;
        window.localStorage.setItem(this.tourId, JSON.stringify(false));
    };
}
export default FeatureDiscoveryStore;
